// extracted by mini-css-extract-plugin
module.exports = {"EditorSettings":"SJ7UHucL","firstBlock":"_2of2hC-Q","scrollDiv":"ul4EjHiW","titleContainer":"_2ElcyLob","featuresContainer":"_1HNzIqdh","titlePadding":"_2qyOvN-V","cohortBlockTitle":"_11WHvhJD","titleContent":"_2F0ON4Dy","tabContainer":"_1ZbJ71Sa","mainTab":"hRJ3pcuw","mainTabActive":"_3segKadX"};
    if(module.hot) {
      // 1754515039341
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  